<template>
 <div>
    <Form :model="manageOrderForm" :rules="ruleValidate" label-position="left" ref="manageOrderForm">
        <Row :gutter="10">
            <Col span="24">
                <FormItem prop="pickupConfirmation" label="Pickup Confirmation">
                    <RadioGroup v-model="manageOrderForm.pickupConfirmation">
                        <Radio label="Done"></Radio>
                        <Radio label="Awaiting"></Radio>
                    </RadioGroup>
                </FormItem>
            </Col>
            <Col span="24" style="margin: -20px 0 0 0">
                <Row>
                    <Col span="10">
                        <FormItem prop="orderReadiness" label="Order Readiness">
                            <RadioGroup v-model="manageOrderForm.orderReadiness">
                                <Radio label="Yes"></Radio>
                                <Radio label="No"></Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                    <Col span="14" v-show="manageOrderForm.orderReadiness == 'No'">
                        <FormItem prop="pickUpDate">
                            <DatePicker type="date" v-model="manageOrderForm.orderDate" :options="disableDate"
                                        placeholder="Pickup Date" format="dd/MM/yyyy" style="width: 215px"></DatePicker>
                        </FormItem>
                    </Col>
                </Row>
            </Col>
            <Col span="24">
                <Row :gutter="10">
                    <Col span="11">
                        <Card v-if="orderData">
                            <p style="margin: 4px 0 2px 0;">Name: {{orderData.pickuppartyobject.name}}</p>
                            <p style="margin: 0 0 2px 0;">Adress 1: {{orderData.pickuppartyobject.address[0].add1}}</p>
                            <p style="margin: 0 0 2px 0;">Address 2: {{orderData.pickuppartyobject.address[0].add2}}</p>
                            <p style="margin: 0 0 2px 0;">Area: {{orderData.pickuppartyobject.address[0].area}}</p>
                            <p style="margin: 0 0 2px 0;">City: {{orderData.pickuppartyobject.address[0].city}}</p>
                            <p style="margin: 0 0 2px 0;">State: {{orderData.pickuppartyobject.address[0].state}}</p>
                            <p>Pincode: {{orderData.pickuppartyobject.address[0].pincode}}</p>
                        </Card>
                    </Col>
                    <Col span="2" style="margin-top: 94px;font-size: 21px;"><Icon type="md-arrow-round-forward" style="cursor: pointer" @click="transferData()"></Icon></Col>
                    <Col span="11">
                        <Card>
                            <Form :model="pickupPartyForm" :rules="ruleValidatePickup" label-position="top" ref="pickupPartyForm">
                                <Row :gutter="10">
                                    <Col span="24" style="margin: 0 0 -20px 0">
                                        <FormItem prop="name">
                                            <ApolloQuery :query="query_SEARCH_PICKUPPARTY" :debounce="500" :skip="skip.pickupPartySkip"
                                                         :variables="{pickupPartyFilter:pickupPartyFilter, filterpickupPartyCity:[]}">
                                                <template slot-scope="{ result: { loading, error, data } }">
                                                    <div v-if="loading"> Loading...</div>
                                                    <div v-else-if="error"> Error Occured. {{error}}</div>
                                                    <div v-else>
                                                        <AutoComplete placeholder="Pickup Party" @on-search="onSearchPickupParty($event)"
                                                                      v-model="pickupPartyForm.name">
                                                            <Option :key="index" :value="companyObj.name" :label="companyObj.name"
                                                                    v-for="(companyObj,index) in data?data.addressbookedcompany:[]">
                                                                <div class="ivu-select-item-div" @click="pickupPartyForm.pickupId=companyObj.id">{{companyObj.name}}</div>
                                                            </Option>
                                                        </AutoComplete>
                                                    </div>
                                                </template>
                                            </ApolloQuery>
                                        </FormItem>
                                    </Col>
                                    <Col span="24" style="margin: 0 0 -20px 0">
                                        <FormItem  prop="add1">
                                            <Input placeholder="Address 1" v-model="pickupPartyForm.add1"></Input>
                                        </FormItem>
                                    </Col>
                                    <Col span="24" style="margin: 0 0 -20px 0">
                                        <FormItem  prop="add2">
                                            <Input placeholder="Address 2" v-model="pickupPartyForm.add2"></Input>
                                        </FormItem>
                                    </Col>
                                    <Col span="12" style="margin: 0 0 -20px 0">
                                        <FormItem prop="area">
                                            <Input placeholder="Area" v-model="pickupPartyForm.area"></Input>
                                        </FormItem>
                                    </Col>
                                    <Col span="12" style="margin: 0 0 -20px 0">
                                        <FormItem  prop="pincode">
                                            <Input number placeholder="PIN" v-model="pickupPartyForm.pincode"></Input>
                                        </FormItem>
                                    </Col>
                                    <Col span="12" style="margin: 0 0 -20px 0">
                                        <FormItem  prop="city" >
                                            <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter}"
                                                         :debounce="500" :skip="skip.citySkip">
                                                <template slot-scope="{ result: { loading, error, data } }">
                                                    <div v-if="loading"> Loading...</div>
                                                    <div v-else-if="error"> Error Occured. {{error}}</div>
                                                    <div v-else>
                                                        <AutoComplete placeholder="City" v-model="pickupPartyForm.city"
                                                                      @on-search="onSearchCity">
                                                            <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.territories:[]">
                                                                <div class="ivu-select-item-div">{{cityObj.city}}</div>
                                                            </Option>
                                                        </AutoComplete>
                                                    </div>
                                                </template>
                                            </ApolloQuery>
                                        </FormItem>
                                    </Col>
                                    <Col span="12" style="margin: 0 0 -20px 0">
                                        <FormItem prop="state" >
                                            <ApolloQuery :query="query_SEARCH_STATE" :variables="{stateFilter}"
                                                         :debounce="500" :skip="skip.stateSkip">
                                                <template slot-scope="{ result: { loading, error, data } }">
                                                    <div v-if="loading"> Loading...</div>
                                                    <div v-else-if="error"> Error Occured. {{error}}</div>
                                                    <div v-else>
                                                        <AutoComplete placeholder="State" v-model="pickupPartyForm.state"
                                                                      @on-search="onSearchState">
                                                            <Option :key="index" :value="stateObj.state" v-for="(stateObj,index) in data?data.territories:[]">
                                                                <div class="ivu-select-item-div">{{stateObj.state}}</div>
                                                            </Option>
                                                        </AutoComplete>
                                                    </div>
                                                </template>
                                            </ApolloQuery>
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </Col>
            <Col span="24" style="margin: 12px 0 -20px 0">
                <FormItem prop="LRReady">
                    <Checkbox v-model="manageOrderForm.LRReady" @on-change="onTickLR">LR Ready</Checkbox>
                </FormItem>
            </Col>
            <Col span="24">
                <FormItem prop="confirmationEmail">
                    <Checkbox v-model="manageOrderForm.confirmationEmail" @on-change="onTickEmail">Confirmation Email</Checkbox>
                </FormItem>
            </Col>
            <Col span="24">

            </Col>
        </Row>
    </Form>
    <div class="demo-drawer-footer">
        <Button type="primary" @click="saveOtherDetail()">Save</Button>
        <Button type="primary" style="margin-left: 8px" @click="onApprove()">Approve</Button>
        <Poptip v-model="toolTip">
            <div slot="title">Reject Note</div>
            <div slot="content">
                <Form :rules="rejectRule" ref="rejectForm" :model="rejectForm">
                    <FormItem prop="rejectNote"><Input type="textarea" v-model="rejectForm.rejectNote"></Input></FormItem>
                </Form>
                <Button type="primary" style="margin-left: 8px" @click="toolTip=false">Cancel</Button>
                <Button type="primary" style="margin-left: 8px" @click="onReject()">Confirm Reject</Button>
            </div>
            <Button type="primary" style="margin-left: 8px" @click="$refs['rejectForm'].resetFields()">Reject</Button>
        </Poptip>

    </div>
 </div>
</template>

<script>
import {GET_ORDER_DETAIL} from '../../graphql/queries/OrderDetails'
import {ADD_ORDER_DETAIL, ADD_ORDER_DETAIL_UPDATE_ORDER,
    UPDATE_ORDER_DETAIL_UPDATE_ORDER, UPDATE_ORDER_DETAIL} from '../../graphql/mutations/orderDetails'
import {SEARCH_PICKUPPARTY} from '../../graphql/queries/companies'
import { SEARCH_CITY, SEARCH_STATE } from '../../graphql/queries/territories'
import _ from 'lodash'
import moment from 'moment'
import {generateUUID} from "../../Constants/Constant";

export default {
        apollo: {
            orderDetails: {
                query: GET_ORDER_DETAIL,
                variables() {
                    return {
                        orderId: this.orderId
                    }
                },
                // fetchPolicy: 'no-cache',
                result({data, loading}) {
                    if (!loading) {
                        if(data.orderDetails.length){
                            this.orderDetailId = data.orderDetails[0].id;
                            this.initializeData(data.orderDetails[0])
                        }else{
                            this.orderDetailId = '';
                        }
                    }
                }
            }
        },
        name: "AddOrderOtherDetail",
        props: ['orderId', 'orderData'],
        inject: ["getManageOrderDrawer","setManageOrderDrawer"],
        data: function(){
            return{
                query_SEARCH_PICKUPPARTY: SEARCH_PICKUPPARTY,
                query_SEARCH_CITY: SEARCH_CITY,
                query_SEARCH_STATE: SEARCH_STATE,
                mutation_ADD_ORDER_DETAIL: ADD_ORDER_DETAIL,
                mutation_ADD_ORDER_DETAIL_UPDATE_ORDER: ADD_ORDER_DETAIL_UPDATE_ORDER,
                mutation_UPDATE_ORDER_DETAIL_UPDATE_ORDER: UPDATE_ORDER_DETAIL_UPDATE_ORDER,
                mutation_UPDATE_ORDER_DETAIL: UPDATE_ORDER_DETAIL,
                disableDate: {disabledDate (date) {return date && date.valueOf() < Date.now() - 86400000;}},
                manageOrderForm:{
                    pickupConfirmation: 'Done',
                    orderReadiness: 'Yes',
                    orderDate: moment().format('DD/MM/YYYY'),
                    LRReady: false,
                    confirmationEmail: false
                },
                pickupPartyForm:{
                    name: '',
                    pickupId: '',
                    add1: '',
                    add2: '',
                    area: '',
                    pincode: '',
                    state: '',
                    city: ''
                },
                ruleValidate: {},
                ruleValidatePickup: {},
                pickupPartyFilter: '%%',
                cityFilter: '%%',
                stateFilter: '%%',
                skip: {pickupPartySkip: true, citySkip: true, stateSkip: true},
                toolTip: false,
                rejectForm: {rejectNote: ''},
                rejectRule: {rejectNote: [{ required: true, message: 'Enter Note', trigger: 'blur' }]},
                orderDetailId: '',
            }
        },
    methods:{
        onSearchPickupParty: function(val){
            this.pickupPartyFilter = '%' + val + '%';
            this.skip.pickupPartySkip = false;
        },
        onSearchCity: function(val){
            this.cityFilter = '%' + val + '%';
            this.skip.citySkip = false;
        },
        onSearchState: function(val){
            this.stateFilter = '%' + val + '%';
            this.skip.stateSkip = false;
        },
        initializeData(orderDetail){
            this.pickupPartyForm.name = orderDetail.pickupPoint.pickupPartyName;
            this.pickupPartyForm.pickupId = orderDetail.pickupPoint.pickupPartyId;
            this.pickupPartyForm.add1 = orderDetail.pickupPoint.add1;
            this.pickupPartyForm.add2 = orderDetail.pickupPoint.add2;
            this.pickupPartyForm.area = orderDetail.pickupPoint.area;
            this.pickupPartyForm.pincode = orderDetail.pickupPoint.pincode;
            this.pickupPartyForm.state = orderDetail.pickupPoint.state;
            this.pickupPartyForm.city = orderDetail.pickupPoint.city;
            this.manageOrderForm.pickupConfirmation = orderDetail.pickupConfirmation;
            this.manageOrderForm.orderReadiness = orderDetail.orderReadiness.isOrderReady? 'Yes': 'No';
            if(!orderDetail.orderReadiness.isOrderReady){
                this.manageOrderForm.orderDate = moment(orderDetail.orderReadiness.pickupDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
            }
            this.manageOrderForm.LRReady = orderDetail.lrObject.islrReady;
            this.manageOrderForm.confirmationEmail = orderDetail.lrObject.isEmailSent;
        },
        transferData(){
            this.pickupPartyForm.name = this.orderData.pickuppartyobject.name;
            this.pickupPartyForm.pickupId = this.orderData.pickuppartyobject.id;
            this.pickupPartyForm.add1 = this.orderData.pickuppartyobject.address[0].add1;
            this.pickupPartyForm.add2 = this.orderData.pickuppartyobject.address[0].add2;
            this.pickupPartyForm.area = this.orderData.pickuppartyobject.address[0].area;
            this.pickupPartyForm.pincode = this.orderData.pickuppartyobject.address[0].pincode;
            this.pickupPartyForm.state = this.orderData.pickuppartyobject.address[0].state;
            this.pickupPartyForm.city = this.orderData.pickuppartyobject.address[0].city;
        },
        reset: function(){
            this.$refs['manageOrderForm'].resetFields();
            this.$refs['pickupPartyForm'].resetFields();

        },
        onTickLR(val){
            if(val){
                this.$Modal.confirm({
                    title: 'Confirmation',
                    content: '<p>Are You sure want to mark LR Ready ?</p>',
                    onCancel: () => {
                        this.manageOrderForm.LRReady = false;
                    }
                });
            }
        },
        onTickEmail(val){
            if(val){
                this.$Modal.confirm({
                    title: 'Confirmation',
                    content: '<p>Are You sure want to mark Email ?</p>',
                    onCancel: () => {
                        this.manageOrderForm.confirmationEmail = false;
                    }
                });
            }
        },
        onApprove(){
            //Assign internalStatusId of approval
            let internalStatus = '98d24789-d38d-4426-b6bc-1be53a18fb80';
            this.saveOtherDetail(internalStatus)
        },
        onReject(){
            this.$refs['rejectForm'].validate((valid) => {
                if (valid) {
                    this.toolTip = false;
                    //Assign internalStatusId of reject
                    let internalStatus = '912cba99-37cb-41fb-ae2e-2a472200af64';
                    this.saveOtherDetail(internalStatus);
                }
            })
        },
        prepareGraphQlString(status, orderDetailId){
            if(status && !orderDetailId){
                return this.mutation_ADD_ORDER_DETAIL_UPDATE_ORDER;
            }else if(status && orderDetailId){
                return this.mutation_UPDATE_ORDER_DETAIL_UPDATE_ORDER;
            }else if(!status && !orderDetailId){
                return this.mutation_ADD_ORDER_DETAIL;
            }else if(!status && orderDetailId){
                return this.mutation_UPDATE_ORDER_DETAIL;
            }
        },
        async saveOtherDetail(status){
            let response = await this.$apollo.mutate({
                mutation: this.prepareGraphQlString(status, this.orderDetailId),
                variables: {
                    id: generateUUID(),
                    orderReadiness: {
                        isOrderReady: this.manageOrderForm.orderReadiness !== 'No',
                        pickupDate: this.manageOrderForm.orderReadiness === 'No' ? this.manageOrderForm.orderDate : '-'
                    },
                    lrObject: {
                        islrReady: this.manageOrderForm.LRReady,
                        isEmailSent: this.manageOrderForm.confirmationEmail
                    },
                    pickupConfirmation: this.manageOrderForm.pickupConfirmation,
                    pickupPoint: {
                        pickupPartyName: this.pickupPartyForm.name,
                        pickupPartyId: this.pickupPartyForm.pickupId,
                        add1: this.pickupPartyForm.add1,
                        add2: this.pickupPartyForm.add2,
                        area: this.pickupPartyForm.area,
                        pincode: this.pickupPartyForm.pincode,
                        city: this.pickupPartyForm.city,
                        state: this.pickupPartyForm.state
                    },
                    orderId: this.orderId,
                    orderDetailId: this.orderDetailId ? this.orderDetailId : 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
                    internalstatus: status ? status : 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
                    rejectionNote: status==='912cba99-37cb-41fb-ae2e-2a472200af64' ? this.rejectForm.rejectNote : ''
                }                            //internalStatusId of Reject
            })
            if(response.data){
                this.$Message.success('Order detail saved successfully!');
                this.reset();
                this.setManageOrderDrawer(false)
            }
        },
      }
   }
</script>

<style scoped>
/deep/ .ivu-select-item{
    padding: 0px 0px;
}
/deep/ .ivu-select-item-div{
    width: 100%;
    padding: 7px 16px;
}
/deep/ .ivu-date-picker-cells{
    width: 259px !important;
}
/deep/ .ivu-date-picker-cells span{
    width: 37px !important;
    margin: 0;
    font-size: 15px;
}
/deep/ .ivu-auto-complete.ivu-select-dropdown{
    max-height: 200px !important;
}
</style>